const SDK_VERSION = "11.3.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
